import { s } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import type { ReactElement } from 'react';

type ChartEmptyStateProps = {
  message?: string;
  title?: string;
  body?: string;
};

export const ChartEmptyState = ({
  message = 'NO DATA',
  title,
  body,
}: ChartEmptyStateProps): ReactElement => {
  if (title || body) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: s('xxs'),
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
          }}
        >
          {title ? <Box sx={{ fontWeight: 600 }}>{title}</Box> : null}
          {body ? <Box>{body}</Box> : null}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        fontSize: '14px',
      }}
    >
      <Box sx={{ fontWeight: 600, textTransform: 'uppercase' }}>{message}</Box>
    </Box>
  );
};
